import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../../shared/services/auth.service';

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  const auth_service = inject(AuthService);

  if (auth_service.get_token() && !req.url.includes("PayFort")) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${auth_service.get_token()}`,
      },
    });
  }
  // request = request.clone({
  //   url: environment.base_url + request.url
  // });



  return next(req);
};

